import { useNavigate } from 'react-router-dom';

import { LogoIcon } from 'assets';

import LoginForm from 'entities/Auth/components/LoginForm';
import { LoginResponse, login } from 'entities/Auth/sdk';

import Text from 'components/Text';

import { saveToken } from 'utils/storage';

import { URLS } from 'config/urls';

const LoginPage = () => {
  const navigate = useNavigate();
  const handleSave = (data: { email: string; password: string }) => {
    return login(data).then((response: LoginResponse) => {
      saveToken(response.token);
      navigate(URLS.HOME);
    });
  };

  return (
    <>
      <div className="flex h-screen w-screen items-center">
        <div className="flex h-fit w-full flex-col items-center">
          <LogoIcon />
          <div className="m-0 mt-[-40px] flex w-[300px] flex-col gap-[54px]">
            <Text
              classes={{
                root: 'font-medium text-[32px] leading-[48px] text-center'
              }}
            >
              Welcome to EdLight Research Portal
            </Text>
            <LoginForm onSave={handleSave} />
          </div>
        </div>
      </div>
    </>
  );
};
export default LoginPage;
